<template>
  <input
    v-bind="$attrs"
    v-mask="maskConfig"
    @blur="onBlur"
    @keydown="onKeyDown"
    @change="updateValue"
    @keyup="($event) => {
      updateValue($event);
      onkeyup($event);
      }"
    :value="innerValue"
    lang="pt-BR"
  />
</template>
<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask';

  export default {
    inheritAttrs: false,
    name: "base-inner-input",
    $_veeValidate: {
      value() {
        return this.innerValue
      },
      name() {
        return this.name
      }
    },
    props: {
      mask: String,
      value: [String, Number],
      name: String,
      required: Boolean,
    },
    data() {
      return {
        focused: false,
        innerValue: this.parseValue(this.value),
      };
    },
    computed: {
      maskConfig () {
        if (this.mask === 'money') return createNumberMask({
          prefix: 'R$ ',
          thousandsSeparatorSymbol: '.',
          decimalSymbol: ',',
          allowDecimal: true,
          includeThousandsSeparator: true,
          allowNegative: false
        })

        if (this.mask === 'volume') return createNumberMask({
          prefix: '',
          thousandsSeparatorSymbol: '.',
          decimalSymbol: ',',
          allowDecimal: true,
          includeThousandsSeparator: true,
          allowNegative: false,
          decimalLimit: 3
        })

        if (this.mask === 'integer') return createNumberMask({
          prefix: '',
          thousandsSeparatorSymbol: '.',
          allowDecimal: false,
          includeThousandsSeparator: true,
          allowNegative: false
        })

        if (this.mask === 'percentage') return createNumberMask({
          prefix: '',
          suffix: ' %',
          thousandsSeparatorSymbol: '.',
          decimalSymbol: ',',
          allowDecimal: true,
          includeThousandsSeparator: true,
          allowNegative: false,
        })

        if (this.mask === 'customPercentage') return customPercentageMask;
        if (this.mask === 'potato') return potatoMask
        if (this.mask === 'phone')  return phoneMask
        if (this.mask === 'time')   return timeMask
        if (this.mask === 'cnpj')   return cnpjMask
        if (this.mask === 'cep')    return cepMask
        if (this.mask === 'cpf')    return cpfMask
        if (this.mask === 'rg')     return rgMask

        return ''
      }
    },
    methods: {
      updateValue(evt) {
        this.innerValue = evt.target.value
        this.$emit("input", this.unparseValue(this.innerValue));
      },
      onFocus(evt) {
        this.focused = true;
        this.$emit("focus", evt);
      },
      onBlur(evt) {
        this.focused = false;
        this.$emit("blur", evt);
      },
      onKeyDown(evt) {
        this.$emit("keydown", evt);
      },
      onkeyup(evt) {
        this.$emit("keyup", evt);
      },
      parseValue(val) {
        if (!val) return val;

        if (['money', 'volume', 'percentage', 'integer'].includes(this.mask)) {
          return val.toString()
                    .split(/^(.+)\.(\w+$)$/)
                    .filter(a => a)
                    .map(e => e = e.replaceAll(/[.,]/g, ''))
                    .join(',')
        }

        if (typeof(val) === 'string' || !val) return val


        return val.toString()
      },
      unparseValue(val) {
        if (!val) return val;

        if (['money', 'volume', 'percentage', 'integer'].includes(this.mask)) {
          const v = val.toString()
                       .split(/^(.+),(\w+$)$/)
                       .filter(a => a)
                       .map(e => e = e.replaceAll(/[.\D]/g, ''))
                       .join('.')

          return parseFloat(v)
        }
        
        if (typeof(this.value) === 'string') return val.toString()

        return val
      }
    },
    watch: {
      value (val) {
        this.innerValue = this.parseValue(val)
      }
    }
  };

  export function timeMask(value) {
    const hours = [
      /[0-2]/,
      value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/,
    ];
    const minutes = [/[0-5]/, /[0-9]/];
    return value.length > 2
      ? [...hours, ':', ...minutes]
      : hours;
  }

  export function potatoMask(_value) {
    return [/p/i,/o/i,/t/i,/a/i,/t/i,/o/i]
  }

  export function cepMask(_value) {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
  }

  export function cpfMask(_value) {
    return [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
  }

  export function rgMask(_value) {
    return [/\d/,/\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/]
  }

  // ##.###.###/####-##
  export function cnpjMask(_value) {
    return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
  }

  export function phoneMask(value) {
    const eightDigits = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/ ,/\d/, /\d/, /\d/]
    const nineDigits  = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/ ,/\d/, /\d/, /\d/]
    return value.length > 14 ? nineDigits : eightDigits
  }
  export function customPercentageMask() {
  const prefix = '';
  const suffix = ' %';
  const thousandsSeparatorSymbol = '.';
  const decimalSymbol = ',';
  const allowDecimal = true;
  const includeThousandsSeparator = true;
  const allowNegative = false;
  const decimalLimit = 3;

  return createNumberMask({
    prefix,
    suffix,
    thousandsSeparatorSymbol,
    decimalSymbol,
    allowDecimal,
    includeThousandsSeparator,
    allowNegative,
    decimalLimit,
  });
}
</script>
<style>
</style>
